// import { IconButton } from "@mui/material";
import styles from "./backDrop.module.css";
// import { Cancel } from "@mui/icons-material";
// import { useTranslation } from "react-i18next";
const BackDrop = ({ open, handleCancelRequest }) => {
  // const { t } = useTranslation();
  return (
    <div
      className={
        open
          ? `${styles.backdropContainer} ${styles["show-backdrop"]} flex flex-col`
          : styles.hideBackdrop
      }
    >
      <img src="/assets/imgs/logo.gif" alt="logo" />
      {/* {handleCancelRequest && (
        <IconButton
          color="error"
          component="label"
          onClick={handleCancelRequest}
        >
          {t("cancel")} <Cancel />
        </IconButton>
      )} */}
    </div>
  );
};

export default BackDrop;
